






import { Component, Prop, Vue } from 'vue-property-decorator'
import { area as coresDaArea } from '@/shareds/novidades/tema'

@Component
export default class EtiquetaDeArea extends Vue {
	@Prop({ type: String, required: true }) area!: string
	@Prop({ type: Boolean, default: false }) icone!: boolean

	get cores() {
		return coresDaArea(this.area)
	}

	get estilo() {
		return this.$vuetify.theme.dark
			? { color: this.cores.corNoEscuro }
			: { color: this.cores.cor, background: this.cores.fundo }
	}
}
